import React from "react";
import {
  FlatButton,
  TextField,
  Checkbox,
  Toggle,
  AutoComplete
} from "material-ui";
import { commitMutation, graphql } from "react-relay";
import PropTypes from "prop-types";
import moment from "moment";
import { Prompt } from "react-router-dom";

import environment from "../../relay/environment";
import DateRange from "../DateRangeComponent";
import DateField from "../DateFieldComponent";
import DailyRates from "./DailyRates";
import search from "../../rest";

export default class EditSegment extends React.Component {
  static propTypes = {
    segment: PropTypes.shape().isRequired,
    onComplete: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const {
      segment: {
        category,
        smokingRoom,
        numAdults,
        numChildren,
        startDate,
        endDate,
        cancellationDeadline,
        sabreLocator,
        confirmationNumber,
        cancellationNumber,
        rates,
        currency,
        averageDailyRate,
        bedType,
        amenityProgram,
        vendor
      }
    } = this.props;

    this.state = {
      vendorId: vendor ? vendor.id : "",
      vendorName: vendor ? vendor.name : "",
      category,
      smokingRoom,
      numAdults,
      numChildren,
      startDate,
      endDate,
      cancellationDeadline,
      sabreLocator,
      confirmationNumber,
      cancellationNumber,
      rates,
      currency,
      averageDailyRate,
      note: "",
      bedType,
      amenityProgram,
      segmentAutocompleteData: [],
      saving: false
    };

    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill"); // eslint-disable-line global-require
    }
  }

  updateTextField = field => e => {
    const {
      target: { value }
    } = e;

    const newState = {};
    newState[field] = value;
    this.setState(newState);
  };

  updateNote = note => {
    this.setState({ note });
  };

  updateSmoking = (e, checked) => {
    this.setState({ smokingRoom: checked });
  };

  updateDates = e => {
    const { startDate, endDate } = e;

    this.setState({ startDate, endDate });
  };

  updateRates = (rates, currency) => {
    this.setState({ rates, currency });
  };

  amenityOnNewRequest = chosenRequest => {
    this.setState({
      amenityProgram: chosenRequest
    });
  };

  amenityOnUpdateInput = searchText => {
    this.setState({
      amenityProgram: searchText
    });
  };

  autoCompleteFilter = (searchText, key) => {
    const normalKey = key.toLowerCase();
    const normalText = searchText.toLowerCase();
    return searchText !== "" && normalKey.indexOf(normalText) !== -1;
  };

  handleUpdateSegmentAutocomplete = value => {
    search("auto/vendor", value)
      .then(response => {
        const { objects } = response;
        this.setState({
          vendor: value,
          segmentAutocompleteData: objects.map(object => ({
            text: object.name,
            value: object.relayId,
            name: object.name,
            score: object.score
          }))
        });
      })
      .catch(response => {
        console.log(response);
      });
  };

  vendorSelected = (selected, index) => {
    if (index !== -1) {
      const { value: vendorId, name: vendorName } = selected;

      this.setState({ vendorId, vendorName });
    }
  };

  save = () => {
    this.setState({ saving: true });

    const {
      segment: { id: segmentId },
      onComplete
    } = this.props;
    const {
      category,
      smokingRoom,
      numAdults,
      numChildren,
      cancellationDeadline,
      sabreLocator,
      confirmationNumber,
      cancellationNumber,
      rates,
      averageDailyRate,
      note,
      bedType,
      amenityProgram,
      vendorId
    } = this.state;
    let { startDate, endDate, currency } = this.state;

    if (moment.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (moment.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    if (confirmationNumber && !currency) {
      const setUSD = confirm(
        "You have not set a currency for this segment, do you want to default to USD?"
      );

      if (setUSD) {
        currency = "USD";
      } else {
        this.setState({ saving: false });
        return;
      }
    }

    commitMutation(environment, {
      mutation: graphql`
        mutation EditSegment_EditSegment_Mutation($input: EditSegmentInput!) {
          editSegment(input: $input) {
            segment {
              id
              vendor {
                id
                name
                amenityPrograms
              }
              trip {
                id
                searchId
                dateString
                startDate
                endDate
                dropbox
                invoice
                draftVip
                book
                cancel
                welcomeHome
                tasks {
                  taskType
                  description
                  completed
                  voided
                  history {
                    name
                    action
                    timestamp
                  }
                }
              }
              name
              dateString
              startDate
              endDate
              category
              bedType
              amenityProgram
              numAdults
              numChildren
              smokingRoom
              rates
              currency
              averageDailyRate
              cancellationDeadline
              dropbox
              invoiced
              vipDrafted
              vipSent
              booked
              cancelled
              sabreLocator
              confirmationNumber
              cancellationNumber
              vipLetter
              notes {
                id
                owner {
                  id
                  firstName
                }
                content
                created
              }
            }
          }
        }
      `,
      variables: {
        input: {
          segmentId,
          vendorId,
          category,
          smokingRoom,
          numAdults,
          numChildren,
          startDate,
          endDate,
          cancellationDeadline,
          sabreLocator,
          confirmationNumber,
          cancellationNumber,
          rates,
          currency,
          averageDailyRate,
          note,
          bedType,
          amenityProgram
        }
      },
      onCompleted: () => onComplete(),
      onError: err => {
        alert(err);
        this.setState({ saving: false });
      }
    });
  };

  toggleAverageDailyRate = e => {
    const {
      target: { checked }
    } = e;
    this.setState({ averageDailyRate: checked });
  };

  render() {
    const {
      onComplete,
      segment: { vendor }
    } = this.props;
    const {
      category,
      smokingRoom,
      numAdults,
      numChildren,
      startDate,
      endDate,
      cancellationDeadline,
      sabreLocator,
      confirmationNumber,
      cancellationNumber,
      rates,
      currency,
      averageDailyRate,
      note,
      bedType,
      amenityProgram,
      segmentAutocompleteData,
      vendorName,
      saving
    } = this.state;

    return (
      <div>
        <Prompt message="A segment is still being editing, leaving now will discard any changes made." />
        <div style={styles.editFields}>
          <AutoComplete
            searchText={vendorName}
            style={styles.formFieldStyle}
            menuStyle={{ width: 500 }}
            listStyle={{ width: 500 }}
            floatingLabelText="Vendor"
            dataSource={segmentAutocompleteData}
            onUpdateInput={this.handleUpdateSegmentAutocomplete}
            onNewRequest={this.vendorSelected}
            filter={() => true}
            fullWidth
          />

          <TextField
            floatingLabelText="Room Category"
            value={category}
            onChange={this.updateTextField("category")}
          />
          <TextField
            floatingLabelText="Bedding"
            value={bedType}
            onChange={this.updateTextField("bedType")}
          />
          <AutoComplete
            floatingLabelText="Amenity Program"
            menuStyle={{ width: 500 }}
            listStyle={{ width: 500 }}
            dataSource={vendor ? vendor.amenityPrograms : []}
            onUpdateInput={this.amenityOnUpdateInput}
            onNewRequest={this.amenityOnNewRequest}
            searchText={amenityProgram}
            filter={this.autoCompleteFilter}
          />
          <Checkbox
            label="Smoking"
            checked={smokingRoom}
            onCheck={this.updateSmoking}
          />
          <TextField
            floatingLabelText="Number of Adults"
            value={numAdults}
            type="number"
            onChange={this.updateTextField("numAdults")}
          />
          <TextField
            floatingLabelText="Number of Children"
            value={numChildren}
            type="number"
            onChange={this.updateTextField("numChildren")}
          />
          <DateRange
            startValue={startDate}
            endValue={endDate}
            startLabel="Check-in Date"
            endLabel="Check-out Date"
            onChange={this.updateDates}
          />
          <DateField
            floatingLabelText="Cancellation Deadline"
            value={cancellationDeadline || ""}
            onChange={this.updateTextField("cancellationDeadline")}
          />
          <TextField
            floatingLabelText="SABRE Locator"
            value={sabreLocator}
            onChange={this.updateTextField("sabreLocator")}
          />
          <TextField
            floatingLabelText="Confirmation Number"
            value={confirmationNumber}
            onChange={this.updateTextField("confirmationNumber")}
          />
          <TextField
            floatingLabelText="Cancellation Number"
            value={cancellationNumber}
            onChange={this.updateTextField("cancellationNumber")}
            disabled={confirmationNumber === ""}
          />
        </div>
        <Toggle
          checked={averageDailyRate}
          onClick={this.toggleAverageDailyRate}
          label={averageDailyRate ? "Average Daily Rate" : "Daily Rates"}
          labelPosition="right"
        />
        <DailyRates
          editing
          startDate={startDate}
          endDate={endDate}
          rates={rates}
          currency={currency}
          average={averageDailyRate}
          onChange={this.updateRates}
        />
        <this.ReactQuill value={note} onChange={this.updateNote} />
        <FlatButton label="Cancel" secondary onTouchTap={onComplete} />
        <FlatButton
          label="Save"
          primary
          onTouchTap={this.save}
          disabled={saving}
        />
      </div>
    );
  }
}

const styles = {
  editFields: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  }
};



// WEBPACK FOOTER //
// /src/components/Trips/EditSegment.js